import './becoder-loading.css';

/** Ant Design supplies the size and positioning through its indicator class. */
export function BecoderLoadingIndicator({ className = '' }: { className?: string }) {
  return <span className={`becoder-loading ${className}`} aria-hidden="true">
    <svg viewBox="0 0 40 40" fill="none" focusable="false">
      <circle className="becoder-loading-track" cx="20" cy="20" r="18" stroke="currentColor" strokeWidth="1.5" />
      <g className="becoder-loading-orbit">
        <circle cx="20" cy="20" r="18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="24 90" />
      </g>
      <g className="becoder-loading-mark">
        <rect x="7" y="7" width="26" height="26" rx="7" fill="currentColor" />
        <path fill="#fff" fillRule="evenodd" d="M14 11.5h6.7c4 0 6.1 1.6 6.1 4.4 0 1.8-1 3-2.4 3.6 2 .5 3.1 1.9 3.1 4 0 3.2-2.5 5-6.7 5H14v-17Zm4 3.3v3.4h2.3c1.8 0 2.6-.5 2.6-1.7 0-1.1-.8-1.7-2.5-1.7H18Zm0 6.5v3.8h2.8c1.8 0 2.7-.6 2.7-1.9s-.9-1.9-2.8-1.9H18Z" />
      </g>
    </svg>
  </span>;
}
